<template>
    <div class="container">
        <div class="row hero_section align-items-end">
            <div class="col-lg-7 left">
                <counts />
            </div>
            <div class="col-lg-5 right">
                <top-content-uploaders />
            </div>
        </div>

        <div class="mt-5">
            <!-- Map -->
            <v-map />
        </div>

        <div class="row animating_div">
            <div class="col-lg-8 animated_circle">
                <stats-wheel @click:path="selectStatsWheelPath" />
            </div>

            <!-- Gallery Carousel -->
            <div class="col-lg-4 carousel_card">
                <gallery />
            </div>
        </div>

        <div class="row teacher-details g-4">
            <div v-if="!['District', 'Upazila'].includes(selectedStatsWheelPath)" class="col-md-12">
                <div class="teacher-title mb-1">
                    <h3 class="title text-center">
                        {{ selectedStatsWheelPath === 'init' ? __('Teacher') : __(selectedStatsWheelPath) }}
                    </h3>
                </div>
            </div>

            <template v-if="['init', 'Teacher', 'Ambassador'].includes(selectedStatsWheelPath)">
                <!-- Institution Type Graph -->
                <div class="col-md-6 col-lg-4">
                    <institution-type-wise-user-count />
                </div>

                <!-- Gender Graph -->
                <div class="col-md-6 col-lg-4">
                    <gender-wise-user-count />
                </div>

                <!-- Teacher Designation -->
                <div class="col-md-6 col-lg-4">
                    <designation-wise-user-count />
                </div>
            </template>

            <template v-if="['init', 'Teacher'].includes(selectedStatsWheelPath)">
                <div class="col-md-6 col-lg-4">
                    <!-- Age Graph -->
                    <age-wise-user-count />
                </div>

                <!-- Subject Table -->
                <div class="col-md-6 col-lg-4">
                    <subject-wise-user-count />
                </div>

                <!-- Educational Qualification -->
                <div class="col-md-6 col-lg-4">
                    <education-wise-user-count />
                </div>
            </template>

            <template v-if="selectedStatsWheelPath === 'Ambassador'">
                <!-- District wise highest ambassador -->
                <div class="col-md-6 col-lg-4">
                    <district-wise-highest-ambassador-count />
                </div>

                <!-- Upazila wise highest ambassador -->
                <div class="col-md-6 col-lg-4">
                    <upazila-wise-highest-ambassador-count />
                </div>

                <!-- Top active ambassador -->
                <div class="col-md-6 col-lg-4">
                    <top-active-ambassadors />
                </div>
            </template>

            <template v-if="selectedStatsWheelPath === 'Institution'">
                <!-- Institution type wise institution -->
                <div class="col-md-6 col-lg-4">
                    <type-wise-institution-count />
                </div>

                <!-- Division wise institution -->
                <div class="col-md-6 col-lg-4">
                    <division-wise-institution-count />
                </div>

                <!-- District wise institution -->
                <div class="col-md-6 col-lg-4">
                    <district-wise-institution-count />
                </div>

                <!-- Upazila wise institution -->
                <div class="col-md-6 col-lg-4">
                    <upazila-wise-institution-count />
                </div>

                <!-- Top active institution -->
                <div class="col-md-6 col-lg-4">
                    <top-active-institutions />
                </div>
            </template>

            <template v-if="selectedStatsWheelPath === 'Content'">
                <!-- Top uploader -->
                <div class="col-md-6 col-lg-4">
                    <top-uploaders />
                </div>
            </template>

            <!-- According to Location -->
            <div class="col-md-12 according_to_location">
                <location-wise-user-count />
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import Counts from './components/Counts.vue';
import TopContentUploaders from './components/TopContentUploaders.vue';
import vMap from './components/Map.vue';
import StatsWheel from './components/StatsWheel.vue';
import Gallery from './components/Gallery.vue';
import InstitutionTypeWiseUserCount from './components/InstitutionTypeWiseUserCount.vue';
import GenderWiseUserCount from './components/GenderWiseUserCount.vue';
import DesignationWiseUserCount from './components/DesignationWiseUserCount.vue';
import AgeWiseUserCount from './components/AgeWiseUserCount.vue';
import SubjectWiseUserCount from './components/SubjectWiseUserCount.vue';
import EducationWiseUserCount from './components/EducationWiseUserCount.vue';
import DistrictWiseHighestAmbassadorCount from './components/DistrictWiseHighestAmbassadorCount.vue';
import UpazilaWiseHighestAmbassadorCount from './components/UpazilaWiseHighestAmbassadorCount.vue';
import TopActiveAmbassadors from './components/TopActiveAmbassadors.vue';
import TypeWiseInstitutionCount from './components/TypeWiseInstitutionCount.vue';
import DivisionWiseInstitutionCount from './components/DivisionWiseInstitutionCount.vue';
import DistrictWiseInstitutionCount from './components/DistrictWiseInstitutionCount.vue';
import UpazilaWiseInstitutionCount from './components/UpazilaWiseInstitutionCount.vue';
import TopActiveInstitutions from './components/TopActiveInstitutions.vue';
import TopUploaders from './components/TopUploaders.vue';
import LocationWiseUserCount from './components/LocationWiseUserCount.vue';

export default {
    components: {
        Counts,
        TopContentUploaders,
        vMap,
        StatsWheel,
        Gallery,
        InstitutionTypeWiseUserCount,
        GenderWiseUserCount,
        DesignationWiseUserCount,
        AgeWiseUserCount,
        SubjectWiseUserCount,
        EducationWiseUserCount,
        DistrictWiseHighestAmbassadorCount,
        UpazilaWiseHighestAmbassadorCount,
        TopActiveAmbassadors,
        TypeWiseInstitutionCount,
        DivisionWiseInstitutionCount,
        DistrictWiseInstitutionCount,
        UpazilaWiseInstitutionCount,
        TopActiveInstitutions,
        TopUploaders,
        LocationWiseUserCount,
    },

    data() {
        return {
            selectedStatsWheelPath: 'init',
            selectedStatsWheelArgs: null,
        }
    },

    provide() {
        return {
            defaultLocationIds: window['DEFAULT_LOCATION_IDS'],
            selectedStatsWheelPath: computed(() => this.selectedStatsWheelPath),
            selectedStatsWheelArgs: computed(() => this.selectedStatsWheelArgs),
        }
    },

    methods: {
        selectStatsWheelPath(name, ...args) {
            this.selectedStatsWheelPath = name;
            this.selectedStatsWheelArgs = args;
        },
    },
}
</script>